export const phoneNumbers = [
    '01126351365'
]
export const whatsappNumbers = [
    '+201008641756'
]
